import React from 'react';
import ServiceOption from '../components/ServiceOption';
import serviceOptionsData from '../data/serviceOptions.json';
import styles from '../assets/styles/ServiceCategory.module.css';

const ServiceCategory = ({ category }) => {
  const serviceOptions = serviceOptionsData[category].map((option, index) => (
    <ServiceOption 
      key={index} 
      title={option.title} 
      description={option.description}
      path={option.path}
    />
  ));

  return (
    <div className={styles.serviceCategoryContainer}>
      <div className={styles.serviceCategory}>
        <div className={styles.title}>{category}</div>
        <div>Select an option below to learn more.</div>
        <div className={styles.options}>
          {serviceOptions}
        </div>
      </div>
    </div>
  );
};

export default ServiceCategory;